module.exports = __webpack_public_path__ + "media/public/images/social/messanger-71078cbdb7d4108072e7bf3fd5a03915.svg";